// extracted by mini-css-extract-plugin
export default {"create":"styles_create__R9SHN","row":"styles_row__31fTj","col":"styles_col__m8MPP","flexRight":"styles_flexRight__zhOP0"};